import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {subscribeMissedLead} from "@/api/participant.js";

export const MissedView = ({contestId, slug, mode = 'MISSED'}) => {
    const {t} = useTranslation();
    const [email, setEmail] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const config = {
        NO_CONTEST: {
            icon: '💤',
            title: t('no_contest.title', "C'EST CALME..."),
            subtitle: t('no_contest.subtitle', "Trop calme."),
            description: t('no_contest.description', "Aucun match à l'affiche pour le moment. Laisse ton mail, on te réveille dès que ça repart !"),
            successTitle: t('no_contest.success_title', "C'est noté !"),
            successMsg: t('no_contest.success_msg', "On te tient au courant.")
        },
        MISSED: {
            icon: '🔔',
            title: t('missed.title'),
            subtitle: t('missed.subtitle'),
            description: t('missed.description'),
            successTitle: t('missed.success_title'),
            successMsg: t('missed.success_msg')
        }
    };

    const currentConfig = config[mode] || config.MISSED;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) return;

        setIsLoading(true);

        try {
            await subscribeMissedLead(email, contestId, slug);
            setIsSubmitted(true);
        } catch (error) {
            console.error("Erreur inscription:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="pt-8 pb-10 animate-fade-in px-4">
            <div
                className="bg-white rounded-3xl p-8 text-center shadow-soft border border-slate-50 relative overflow-hidden">

                <div
                    className="absolute top-0 right-0 w-32 h-32 bg-yellow-100 rounded-full blur-3xl opacity-30 -translate-y-1/2 translate-x-1/2"></div>

                {!isSubmitted ? (
                    <>
                        <div
                            className="w-16 h-16 mx-auto mb-6 bg-slate-50 rounded-2xl flex items-center justify-center rotate-3 shadow-sm border border-slate-100 text-3xl">
                            {currentConfig.icon}
                        </div>

                        <h2 className="text-xl font-black text-slate-800 mb-2 uppercase tracking-tight">
                            {currentConfig.title}
                        </h2>

                        <p className="text-sm font-medium text-slate-400 mb-6">
                            {currentConfig.subtitle}
                        </p>

                        <p className="text-sm text-slate-500 leading-relaxed mb-8 font-light">
                            {currentConfig.description}
                        </p>

                        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
                            <input
                                type="email"
                                required
                                placeholder={t('missed.placeholder')}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={isLoading}
                                className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-slate-800 focus:ring-1 focus:ring-slate-800 text-slate-800 font-medium transition-all text-center placeholder:text-slate-300 disabled:opacity-50"
                            />

                            <button
                                type="submit"
                                disabled={isLoading}
                                className="w-full py-4 bg-action-green text-white font-bold rounded-xl shadow-lg hover:brightness-110 active:scale-98 transition-all disabled:opacity-70 disabled:cursor-not-allowed flex justify-center items-center"
                            >
                                {isLoading ? (
                                    <span
                                        className="animate-spin w-5 h-5 border-2 border-white border-t-transparent rounded-full"/>
                                ) : (
                                    t('missed.cta_btn')
                                )}
                            </button>
                        </form>
                    </>
                ) : (
                    <div className="py-10 animate-pop-in-flex flex flex-col items-center">
                        <div
                            className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center text-green-600 mb-4 text-2xl">
                            ✓
                        </div>
                        <h3 className="text-lg font-bold text-slate-800 mb-2">{currentConfig.successTitle}</h3>
                        <p className="text-sm text-slate-500">{currentConfig.successMsg}</p>
                    </div>
                )}
            </div>
        </div>
    );
};